@if (root && item.visible && item.items) {
    <div class="layout-menuitem-root-text">
        {{ item.label }}
    </div>
}
@if ((!item.routerLink || item.items) && item.visible) {
    <a
        [attr.href]="item.url"
        (click)="itemClick($event)"
        (mouseenter)="onMouseEnter()"
        [ngClass]="item.styleClass"
        [attr.target]="item.target"
        tabindex="0"
        pRipple
        [pTooltip]="item.label ? item.label : ''"
        [tooltipDisabled]="!(layoutService.isCompact() && root && !active())"
    >
        @if (item.svgIcon) {
            <svg-icon [name]="item.svgIcon" class="layout-menuitem-icon"></svg-icon>
        } @else {
            <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
        }
        <span class="layout-menuitem-text">{{ item.label }}</span>
        @if (item.badge) {
            <p-badge [size]="'small'" [value]="item.badge"></p-badge>
        }
        @if (item.items) {
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
        }
    </a>
}

@if (item.routerLink && !item.items && item.visible) {
    <a
        class="link-item"
        (click)="itemClick($event)"
        (mouseenter)="onMouseEnter()"
        [ngClass]="item.styleClass"
        [routerLink]="item.routerLink"
        routerLinkActive="active-route"
        [routerLinkActiveOptions]="
            item.routerLinkActiveOptions || {
                paths: 'exact',
                queryParams: 'ignored',
                matrixParams: 'ignored',
                fragment: 'ignored'
            }
        "
        [fragment]="item.fragment"
        [queryParamsHandling]="item.queryParamsHandling"
        [preserveFragment]="item.preserveFragment"
        [skipLocationChange]="item.skipLocationChange"
        [replaceUrl]="item.replaceUrl"
        [state]="item.state"
        [queryParams]="item.queryParams"
        [attr.target]="item.target"
        tabindex="0"
        pRipple
        [pTooltip]="item.label ? item.label : ''"
        [tooltipDisabled]="!(layoutService.isCompact() && root)"
    >
        @if (item.svgIcon) {
            <svg-icon [name]="item.svgIcon" class="layout-menuitem-icon"></svg-icon>
        } @else {
            <i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
        }
        <span class="layout-menuitem-text">{{ item.label }}</span>
        @if (item.badge) {
            <p-badge [size]="'small'" [value]="item.badge"></p-badge>
        }
        @if (item.items) {
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
        }
    </a>
}

@if (addMaxHeightDirective()) {
    @if (item.items && item.visible) {
        <ul [@children]="submenuAnimation()" appMaxHeightViewport>
            @for (child of item.items; track $index; let i = $index) {
                <li
                    app-menu-item
                    [item]="child"
                    [index]="i"
                    [parentKey]="key"
                    [class]="child.badgeStyleClass ?? ''"
                ></li>
            }
        </ul>
    }
} @else {
    @if (item.items && item.visible) {
        <ul [@children]="submenuAnimation()">
            @for (child of item.items; track $index; let i = $index) {
                <li
                    app-menu-item
                    [item]="child"
                    [index]="i"
                    [parentKey]="key"
                    [class]="child.badgeStyleClass ?? ''"
                ></li>
            }
        </ul>
    }
}
